angular.module("UI8.components").component("hirePaywallModal", {
  template: `<div class="modal modal--hire-paywall">
      <button class="modal__close" ui8-toggle-class="hire-paywall-modal" ui8-track-event="Close Hire Paywall"></button>
      <div class="modal__container">
        <div class="hirepay">
          <h1 class="hirepay__title">UI8 Hire</h1>
          <p class="hirepay__subtitle">Get discovered and hired by clients — through your profile, your shots and your inbox.</p>

          <div class="hirepay__tabs">
            <button type="button" ng-class="{active: $ctrl.plan === 'monthly'}" ng-click="$ctrl.plan = 'monthly'">Monthly</button>
            <button type="button" ng-class="{active: $ctrl.plan === 'yearly'}" ng-click="$ctrl.plan = 'yearly'">
              Yearly
              <span>Save 18%</span>
            </button>
          </div>

          <div class="hirepay__price">
            <span class="hirepay__amount">{{ $ctrl.plan === 'yearly' ? '$79' : '$8' }}</span>
            <span class="hirepay__per">{{ $ctrl.plan === 'yearly' ? 'per year' : 'per month' }}</span>
          </div>

          <ul class="hirepay__features">
            <li>Unlimited client inquiries</li>
            <li>A Verified badge on your profile and messages</li>
            <li>A listing in the hire directory</li>
            <li>Post your work to shots</li>
          </ul>

          <button class="btn hirepay__cta" ng-if="!$ctrl.processing" ng-click="$ctrl.subscribe($ctrl.plan)">Get started</button>
          <div class="loader" ng-if="$ctrl.processing"></div>

          <p class="hirepay__note">Included with any <a href="" ng-click="$ctrl.showPass($event)">All Access Pass</a>. Cancel anytime.</p>
        </div>
      </div>
      <div class="modal__backdrop" ui8-toggle-class="hire-paywall-modal" ui8-track-event="Close Hire Paywall"></div>
    </div>`,

  controller: function (HireService, CartService, FlashService, $scope) {
    var ctrl = this;

    ctrl.plan = "monthly";
    ctrl.processing = false;

    ctrl.subscribe = function (plan) {
      if (!UI8.loggedIn) {
        window.location =
          "/account/login?from=" +
          encodeURIComponent(window.location.pathname);
        return;
      }
      if (ctrl.processing) return;
      ctrl.processing = true;

      if (UI8.hireCheckout === "drawer") return openInCart(UI8.hire[plan]);

      HireService.subscribe(UI8.hire[plan]).then(function (res) {
        if (res && res.link) {
          window.location = res.link;
          return;
        }
        ctrl.processing = false;
        FlashService.set(
          "error",
          (res && res.error) || "Unable to start checkout"
        );
        $scope.$applyAsync();
      });
    };

    // Same hand-off the pass pricing table uses: drop the subscription in
    // the cart and let our own drawer take the payment.
    function openInCart(productId) {
      CartService.addPassToCart(productId).then(function () {
        setTimeout(function () {
          window.scrollLock.disablePageScroll();

          var groupCart = $(".header__cell--cart"),
            groupNext = groupCart.find(".payup__sidebar .payup__btn"),
            groupLayout = groupCart.find(".payup__layout"),
            groupBack = groupCart.find(".payup__back");

          groupNext.on("click", function () {
            groupLayout.addClass("step-checkout");
          });
          groupBack.on("click", function () {
            groupLayout.removeClass("step-checkout");
          });
        }, 10);

        ctrl.processing = false;
        $scope.$applyAsync();
      });

      $("body").removeClass("hire-paywall-modal");
    }

    ctrl.showPass = function ($event) {
      if ($event) $event.preventDefault();
      $("body")
        .removeClass("hire-paywall-modal")
        .addClass("pass-pricing-modal");
    };
  },
});
